import { photoRepository } from '@/storage/photoRepository';

export class SyncService {
    /**
     * Verifica se há internet (via navigator.onLine)
     */
    isOnline(): boolean {
        return navigator.onLine;
    }

    /**
     * Sincroniza todas as fotos pendentes do projeto
     * Retorna o número de fotos sincronizadas com sucesso e o total de tentadas
     */
    async syncPendingPhotos(onProgress?: (current: number, total: number) => void): Promise<{ success: number; total: number; failed: number }> {
        if (!this.isOnline()) {
            throw new Error('Sem conexão com a internet');
        }

        const pendingPhotos = await photoRepository.getPendingPhotos();
        const total = pendingPhotos.length;
        let successCount = 0;
        let failCount = 0;

        if (total === 0) {
            return { success: 0, total: 0, failed: 0 };
        }

        for (let i = 0; i < total; i++) {
            const photoRecord = pendingPhotos[i];
            try {
                const targetUrl = import.meta.env.VITE_API_URL
                    ? `${import.meta.env.VITE_API_URL.replace(/\/$/, '')}/fotos/offline-sync`
                    : '/api/fotos/offline-sync';

                const formData = new FormData();

                // Criar um File a partir do Blob
                const file = new File([photoRecord.foto], `photo_offline_${photoRecord.id}.jpg`, { type: 'image/jpeg' });

                formData.append('foto', file);
                formData.append('maquinaId', photoRecord.maquinaId);
                formData.append('nomeMaquina', photoRecord.nomeMaquina ?? photoRecord.maquinaId);
                formData.append('dataHora', photoRecord.dataHora);
                formData.append('projetoId', photoRecord.projetoId);
                formData.append('offlineId', photoRecord.id);

                // A sessão vai no cookie HttpOnly; `credentials: 'include'` é o
                // que faz o navegador enviá-lo. Não enviamos Content-Type com
                // FormData — o fetch ajusta sozinho, com boundary.
                const response = await fetch(targetUrl, {
                    method: 'POST',
                    credentials: 'include',
                    body: formData
                });

                if (response.ok) {
                    // Marca a foto como sincronizada
                    await photoRepository.markAsSynced(photoRecord.id);
                    successCount++;
                } else {
                    console.error(`Falha ao sincronizar foto ${photoRecord.id}: ${response.status}`);
                    failCount++;
                }
            } catch (err) {
                console.error(`Erro ao sincronizar foto ${photoRecord.id}:`, err);
                failCount++;
            }

            if (onProgress) {
                onProgress(i + 1, total);
            }
        }

        // Opcionalmente, pode deletar as fotos sincronizadas após o sync
        // await photoRepository.deleteSyncedPhotos();

        return { success: successCount, total, failed: failCount };
    }
}

export const syncService = new SyncService();
